<p-floatlabel variant="on" [ngClass]="{'shortInput': selectedView === 'week'}">
  <input pInputText id="crew-label" [(ngModel)]="searchTerm" autocomplete="off" />
  <label for="crew-label"><i class="pi pi-search"></i> Search</label>
</p-floatlabel>

@if (showRecommended) {
  <p-panel header="Recommended" [toggleable]="true" class="innerHeader">
    <div class="p-grid" id="crewPanelList" cdkDropList [cdkDropListData]="allCrews | crewFilter: searchTerm" [cdkDropListDisabled]="!canDrag"
      [cdkDropListConnectedTo]="(selectedView == 'day') ? ['dayOne', 'dayTwo'] : ['dayOne', 'dayTwo', 'dayThree', 'dayFour', 'dayFive', 'daySix', 'daySeven']"
      (cdkDropListDropped)="drop($event)">
      @for (crew of allCrews | crewFilter: searchTerm; track crew) {
        <app-crew-card [ngClass]="{'p-lg-2 p-md-3 p-sm-6': selectedView == 'day', 'p-col-12': selectedView == 'week'}"
        [crew]="crew" cdkDrag></app-crew-card>
      }
    </div>
  </p-panel>
}
<p-panel header="Equipment" [toggleable]="true" class="innerHeader">
  <div class="p-grid" id="equipmentPanelList" cdkDropList [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="allEquipment | equipmentFilter: searchTerm"
    [cdkDropListConnectedTo]="dragAndDropService.allCDKEquipmentListIds" (cdkDropListDropped)="drop($event)">
    @for (equip of allEquipment | equipmentFilter: searchTerm; track equip) {
      <app-equipment-card class="match-height-card"
        [ngClass]="{'p-lg-2 p-md-3 p-sm-6': selectedView == 'day', 'p-col-12': selectedView == 'week', 'p-md-4 p-sm-6 lessPad': selectedView == 'multiDay'}"
        [equipment]="equip" cdkDrag>
      </app-equipment-card>
    }
  </div>
</p-panel>
<p-panel header="Crew" [toggleable]="true" class="innerHeader">
  <div class="p-grid" id="employeePanelList" cdkDropList [cdkDropListData]="allEmployees | peopleFilter: searchTerm" [cdkDropListDisabled]="!canDrag"
    [cdkDropListConnectedTo]="dragAndDropService.allCDKEmployeeListIds" (cdkDropListDropped)="drop($event)">
    @for (employee of allEmployees | peopleFilter: searchTerm; track employee) {
      <app-employee-card class="match-height-card"
        [ngClass]="{'p-lg-2 p-md-3 p-sm-6': selectedView == 'day', 'p-col-12': selectedView == 'week', 'p-md-4 p-sm-6 lessPad': selectedView == 'multiDay'}"
        [employee]="employee" cdkDrag>
      </app-employee-card>
    }
  </div>
</p-panel>